export enum StaticPagesId {
  ticketedEvents = 'ticketed-events',
  privateEvents = 'private-events',
  seasonTickets = 'season-tickets',
  vipMembership = 'vip-memberships-details',
  aboutBankroll = 'about',
}
